import "./footer.css"

function Footer() {
    return (
        <div className="footer">
            <div className="footer-container">
                <div className="top-footer">
                    <div className="t-f-container">
                        <div className="footer-text">
                            <p className="f-paragraph1" style={{ fontWeight: "bold" }}>مشترک شوید تا آخرین اخبار را دریافت کنید</p>
                            <p className="f-paragraph2">ما به شما تمامی اخبار حراج ها و رویداد ها را اطلاع رسانی میکنیم.</p>
                        </div>
                        <div className="cumunication">
                            <input className="e-mail" type="text" placeholder="ایمیل" />
                            <button>مشترک شوید</button>
                        </div>
                    </div>
                </div>
                <div className="middle-footer">
                    <div className="m-f-container">
                        <div className="col">
                            <p style={{ fontWeight: "bold" }}>اطلاعات تماس</p>
                            <ul>
                                <li><span style={{ fontWeight: "500", fontSize: "15px" }}>تلفن : </span> <span className="footer-item">09017409939</span></li>
                                <li><span style={{ fontWeight: "500", fontSize: "15px" }}>ایمیل : </span> <span className="footer-item">sobhansefidkar146@gmail.com</span></li>
                                <li><span style={{ fontWeight: "500", fontSize: "15px" }}>آدرس : </span> <span className="footer-item">خراسان رضوی مشهد</span></li>
                            </ul>
                        </div>
                        <div className="col">
                            <p></p>
                            <ul>
                                <li>
                                    <span className="footer-item">
                                        درباره ما
                                    </span>
                                </li>
                                <li>
                                    <span className="footer-item">
                                        تماس با ما
                                    </span>
                                </li>
                                <li>
                                    <span className="footer-item">
                                        حریم خصوصی
                                    </span>
                                </li>
                                <li>
                                    <span className="footer-item">
                                        شرایط بازگشت کالا
                                    </span>
                                </li>
                                <li>
                                    <span className="footer-item">
                                        مقررات
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div className="col">
                        <p></p>
                            <ul>
                                <li>
                                    <span className="footer-item">
                                        آدرس شعب
                                    </span>
                                </li>
                                <li>
                                    <span className="footer-item">
                                        شرایظ نمایندگی
                                    </span>
                                </li>
                                <li>
                                    <span className="footer-item">
                                        سوالات متداول
                                    </span>
                                </li>
                                <li>
                                    <span className="footer-item">
                                        بلاگ
                                    </span>
                                </li>
                                <li>
                                    <span className="footer-item">
                                        باشگاه مشتریان
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div className="col">
                            <img src="../../images/enamad.png" alt="" />
                        </div>
                    </div>
                </div>
                <div className="bottom-footer">
                    <div className="b-f-container">
                        <p>طراحی توسط سبحان سفیدکار</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;